<script setup>
import ActionsDropdownMenu from '@/components/shared/dropdown/ActionsDropdownMenu.vue'
import {useEmptySlotsCheck} from '@/composables/use-empty-slots-check.js'

//Emits and props
defineEmits([
  'open',
  'close',
])

//Check if default slot is empty
const {isSlotEmpty} = useEmptySlotsCheck()
</script>

<template>
  <ActionsDropdownMenu
    v-if="!isSlotEmpty"
    label="Options"
    v-bind="$attrs"
    @open="$emit('open')"
    @close="$emit('close')"
  >
    <slot />
  </ActionsDropdownMenu>
</template>
